const Footer = () => {
    return (
      <footer className="footer">
        <p>© 2025 Developed by <a href="https://www.linkedin.com/in/natan-macena-ribeiro/" target="_blank" rel="noopener noreferrer">Natan Ribeiro</a></p>
      </footer>
    );
  };
  
  export default Footer;
  